import { CalendarDate } from "@internationalized/date";
import type { DateValue } from "react-aria";

export function stringToDateValue(str: string | null): CalendarDate | null {
	if (!str) {
		return null;
	}
	const [y, m, d] = str.split("-").map(Number);
	if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) {
		return null;
	}
	return new CalendarDate(y, m, d);
}

export function dateValueToCalendarDate(date: DateValue): CalendarDate {
	return new CalendarDate(date.year, date.month, date.day);
}
